import React from 'react';
import { Link } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import './AccessDeniedPage.css';

function AccessDeniedPage() {
  const { canAccessPage } = useAuth();
  const fallbackPath =
    ((canAccessPage?.('orders') || canAccessPage?.('ordersNew')) && '/orders') ||
    (canAccessPage?.('stockHouse') && '/stock-house') ||
    (canAccessPage?.('inventory') && '/inventory') ||
    (canAccessPage?.('batches') && '/batches') ||
    '/login';

  return (
    <div className="access-denied-container">
      <div className="access-denied-box">
        <h1>Access Denied</h1>
        <p>You do not have permission to view this page.</p>
        <p>Please contact an administrator if you believe this is an error.</p>
        <Link to={fallbackPath} className="action-button">Go back</Link>
      </div>
    </div>
  );
}

export default AccessDeniedPage;
